import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { OverlayEventDetail } from '@ionic/core';
import { MealPlanBuilderPage } from '../pages/client/meal-plan-builder/meal-plan-builder.page';

export interface OpenMealPlanBuilderModalOptions {
  userId?: string;
  id?: string;
  type?: 'user' | 'library';
  duplicate?: string;
  mealPlanType?: string;
  mode?: 'mealPlan' | 'menuLibrary';
  backdropDismiss?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class MealPlanBuilderModalService {
  constructor(private modalCtrl: ModalController) {}

  async open(options: OpenMealPlanBuilderModalOptions = {}): Promise<OverlayEventDetail<any>> {
    const modal = await this.modalCtrl.create({
      component: MealPlanBuilderPage,
      cssClass: 'meal-plan-side-modal',
      backdropDismiss: options.backdropDismiss ?? false,
      componentProps: {
        modalContext: {
          mealPlanUser: options.userId,
          id: options.id ?? 'add',
          type: options.type ?? 'user',
          ...(options.duplicate ? { duplicate: options.duplicate } : {}),
          ...(options.mealPlanType ? { mealPlanType: options.mealPlanType } : {}),
          ...(options.mode ? { mode: options.mode } : {}),
        },
      },
    });

    await modal.present();
    return modal.onDidDismiss();
  }
}
